



import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
    apiKey: "AIzaSyADJwR1jyASv56hv5kVJmJ6n2qn-80Qan8",
    authDomain: "krishnagar-publicschool.firebaseapp.com",
    projectId: "krishnagar-publicschool",
    storageBucket: "krishnagar-publicschool.firebasestorage.app",
    messagingSenderId: "16968660661",
    appId: "1:16968660661:web:7a1b7958f1fbacd67830fc",
    measurementId: "G-0MWVS2GGQ6"
 
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;



